/** P32 (Feb 27, 2026) — service-line factory helpers. */
import { todayISO } from './dates';

/** Stable line UID for React reconciliation. Using array index as key
 *  causes state mix-ups when the biller removes a middle row (e.g. row
 *  2 of 4) — child input refs would re-mount onto the next row's data.
 *  randomUUID is available everywhere Rhinobill is supported. */
export const newLineUid = () =>
  (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `line-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const newServiceLine = (overrides = {}) => ({
  _uid: newLineUid(),
  service_date: todayISO(),
  units: 4,
  modifiers: [],
  ...overrides,
});
